<template>
  <img src="/static/images/logo.png">
</template>

<script>
  export default {
    mounted() {
      switch (this.platform()){
        case 'IOS':
          this.$message.error({
            message: '请使用"安卓设备浏览器"内"扫一扫"扫描打开',
            duration: 0,
            center: true,
            showClose: true,
          })
          break;
        case 'Android':
          location.href = '/static/others/chengyi-Android.apk'
          break;
        default:
          this.$message.error({
            message: '请使用"安卓设备浏览器"内"扫一扫"扫描打开',
            duration: 0,
            center: true,
            showClose: true,
          })
          break;
      }
    },
    methods: {
      platform() {
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
          return 'IOS'
        } else if (/(Android)/i.test(navigator.userAgent)) {
          return 'Android'
        } else if (/(Windows Phone)/i.test(navigator.userAgent)) {
          return 'NotPhone'
        }
      }
    }
  }
</script>

<style scoped>
  img {
    margin: 10vh auto;
  }
</style>



// WEBPACK FOOTER //
// src/pages/download/index.vue